module.exports = __webpack_public_path__ + "img/five5Green.c49f009a.jpg";